import { render } from "./admintwo.vue?vue&type=template&id=5badc766&scoped=true"
import script from "./admintwo.vue?vue&type=script&lang=js"
export * from "./admintwo.vue?vue&type=script&lang=js"

import "./admintwo.vue?vue&type=style&index=0&id=5badc766&lang=less&scoped=true"

import exportComponent from "D:\\HbSave\\roc_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5badc766"]])

export default __exports__